// extracted by mini-css-extract-plugin
export default {"slider":"styles_slider__PI1Aj","container":"styles_container__xfAGA","icon":"styles_icon__E59nh","iconContainer":"styles_iconContainer__Zdc7N","marginTop":"styles_marginTop__sDJsf"};